import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/api';
import { API_ENDPOINTS } from '../../config/api';

import { useAlertManager } from '../../components/AlertProvider';
import { MaterialCommunityIcons } from '../../utils/icons';
import { Colors } from '../../theme/colors';
import './VerifyEmailScreen.css';

const VerifyEmailScreen: React.FC = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlertManager();


  const handleVerify = async () => {
    if (!email || !code) {
      showAlert('Error', 'Please enter email and verification code', [{ text: 'OK' }]);
      return;
    }

    setLoading(true);
    try {
      await apiService.post(API_ENDPOINTS.AUTH.VERIFY_EMAIL, {
        email,
        code,
      });
      showAlert('Success', 'Email verified successfully', [
        {
          text: 'OK',
          onPress: () => {
            navigate('/');
          },
        },
      ]);
    } catch (error: any) {
      showAlert('Verification Failed', error.response?.data?.message || 'Invalid code', [{ text: 'OK' }]);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (!email) {
      showAlert('Error', 'Please enter email address', [{ text: 'OK' }]);
      return;
    }

    try {
      await apiService.post(API_ENDPOINTS.AUTH.RESEND_VERIFICATION, {
        identifier: email,
        method: 'EMAIL',
      });
      showAlert('Success', 'Verification code sent', [{ text: 'OK' }]);
    } catch (error: any) {
      showAlert('Error', error.response?.data?.message || 'Failed to resend code', [{ text: 'OK' }]);
    }
  };

  return (
    <div className="verify-email-container">
      <div className="verify-email-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          <MaterialCommunityIcons name="arrow-back" size={24} color={Colors.textPrimary} />
        </button>

        <div className="verify-email-form">
          <div className="icon-container">
            <div className="icon-circle">
              <MaterialCommunityIcons name="email" size={40} color={Colors.primary} />
            </div>
          </div>

          <h1 className="title">Verify Email Address</h1>
          <p className="subtitle">Enter the verification code sent to your email</p>

          <div className="input-wrapper">
            <div className="input-container">
              <MaterialCommunityIcons
                name="email-outline"
                size={22}
                color={Colors.textSecondary}
              />
              <input
                type="email"
                className="input-field"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleVerify()}
              />
            </div>
          </div>

          <div className="input-wrapper">
            <div className="input-container">
              <MaterialCommunityIcons
                name="lock-outline"
                size={22}
                color={Colors.textSecondary}
              />
              <input
                type="text"
                className="input-field"
                placeholder="Verification Code"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                maxLength={6}
                onKeyPress={(e) => e.key === 'Enter' && handleVerify()}
              />
            </div>
          </div>

          <button
            className={`verify-button ${loading ? 'disabled' : ''}`}
            onClick={handleVerify}
            disabled={loading}
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>

          <button className="resend-button" onClick={handleResend}>
            Resend Code
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailScreen;

